import React, { Component } from 'react';
import { toast } from 'react-toastify';

import BaseModal from '../BaseModal';
import Spinner from 'components/Spinner';
import { fetchVsimProducts, changeVsimProduct } from 'api';
import FormError from 'components/FormError';
import { getGeneralModalError } from 'helpers/modals';
import VsimProductsList from './VsimProductsList';

import styles from './styles.module.scss';

class ChangeVsimModal extends Component {
  state = {
    vsimProductsList: null,
    loading: false,
    error: null,
  };

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.isOpen && this.props.isOpen && !this.state.vsimList) {
      this.fetchVsimList();
    }
  }

  fetchVsimList = () => {
    const { simoDeviceId } = this.props;
    this.setState({ loading: true });
    return fetchVsimProducts(simoDeviceId)
      .then((res) => {
        this.setState({ vsimProductsList: res.data, loading: false });
      })
      .catch((e) => {
        this.setState({
          loading: false,
          error:
            e?.response?.data?.detail ||
            e?.response?.data?.message ||
            e.message,
        });
        toast.error('Failed to load vSIM products list');
      });
  };

  handleChangeVsim = (simProductId) => {
    const { simoDeviceId, closeModal } = this.props;
    this.setState({ loading: true });
    return changeVsimProduct(simoDeviceId, { sim_product_id: simProductId })
      .then(() => {
        closeModal();
        toast.success('vSim Changed');
        this.setState({ loading: false });
      })
      .catch((e) => {
        let error;
        const errData = e?.response?.data;
        if (
          errData &&
          errData?.detail?.includes(
            'Unable to change the vSIM due to no privileges on your API account',
          )
        ) {
          error = {
            message:
              'At the moment, the Change vSIM Feature is not available for data plans 50GB and lower, for changing the carrier or card the device is connected to, please submit your request to our support team via Slack.',
          };
        } else {
          error = getGeneralModalError(errData || e);
        }
        toast.error(<FormError error={error} />);
        this.setState({ loading: false });
      });
  };

  render() {
    const { isOpen, closeModal } = this.props;
    const { loading, vsimProductsList, error } = this.state;

    return (
      <BaseModal
        title="Change vSim"
        confirmBtnText=""
        cancelBtnText=""
        onClose={closeModal}
        isOpen={isOpen}
        className={styles.modal}
        contentClassName={styles.content}
      >
        <VsimProductsList
          vsimProducts={vsimProductsList}
          handleChangeVsim={this.handleChangeVsim}
        />
        {error && <FormError error={error} />}
        <Spinner showLoader={loading} />
      </BaseModal>
    );
  }
}

export default ChangeVsimModal;
